/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the RejectBountyResponseRequest interface.
 */
export function instanceOfRejectBountyResponseRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function RejectBountyResponseRequestFromJSON(json) {
    return RejectBountyResponseRequestFromJSONTyped(json, false);
}
export function RejectBountyResponseRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}
export function RejectBountyResponseRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reason': value.reason,
    };
}
